import type { FormEvent } from "react";

export const submitSettingsForm = (
  event: FormEvent<HTMLFormElement>,
  submit: () => Promise<unknown>,
) => {
  event.preventDefault();
  const form = event.currentTarget;
  void submit().then(() =>
    requestAnimationFrame(() => {
      if (!form.isConnected) return;
      const invalid = form.querySelector<HTMLElement>('[aria-invalid="true"]');
      const retry = form.querySelector('[role="alert"]')
        ? form.querySelector<HTMLElement>('button[type="submit"]')
        : null;
      (invalid ?? retry)?.focus();
    }),
  );
};
